import HorizontalDivider from '@/global/components/Divider/HorizontalDivider'
import LinearProgress from '@/global/components/LinearProgress'
import { cn } from '@/lib/utils'
import React, { Fragment } from 'react'
import { RootContext } from './DialogGuideRoot'

interface ContentProps extends React.ComponentProps<'div'> {
    children?: React.ReactNode
}

export type { ContentProps as DialogContentProps }

function Content({ children, className }: ContentProps) {
    return (
        <div
            tabIndex={-1}
            className={cn(
                'flex min-h-0 flex-1 flex-col overflow-y-auto',
                'px-6 py-4 sm:px-8 [scrollbar-gutter:stable]',
                'bg-[color-mix(in_oklab,_var(--popover)_30%,_var(--card))]',
                'border-y',
                className,
            )}
        >
            {children}
        </div>
    )
}

/**
 * Separa o formulário do que vem depois dele — vira barra de progresso
 * enquanto o diálogo está carregando.
 */
const ContentFooter: React.FC<{ children?: React.ReactNode }> = ({
    children,
}) => (
    <RootContext.Consumer>
        {ctx => (
            <Fragment>
                {ctx.loading ? (
                    <div className="w-full my-6">
                        <LinearProgress />
                    </div>
                ) : (
                    <HorizontalDivider className="my-6" />
                )}
                {children}
            </Fragment>
        )}
    </RootContext.Consumer>
)

Content.isConteudoDoDialogo = true
Content.Footer = ContentFooter

export { Content }
